export default "__VITE_ASSET__733d359b__"